// @ts-nocheck

"use client"

import React from "react"
import Image from "next/image"
import Link from "next/link"
import { usePathname } from 'next/navigation'
import { formatPrice } from "@/utils/helper"
import "./styles.scss"

const PropertyItem = ({ bathrooms, built, ean, image, bedrooms, plot, price, title, slug, isExclusive }) => {
    const pathname = usePathname()
    return (
        <div className="w-full max-w-[440px] flex flex-col gap-1 justify-center items-center bg-[#2A3026]">
            <div className="flex flex-col gap-1 justify-center items-center w-full relative">
                {isExclusive 
                    ? <div className="bg-[#EBD29F] text-[#212123] text-[14px] font-bold font-['Comfortaa'] uppercase whitespace-nowrap flex justify-center items-center absolute top-[2px] right-[2px] z-[20] w-[115px] h-[30px]">exclusive</div> 
                    : null
                }
                <Link href={`https://beluxeproperties.com${slug || ""}`} hrefLang="en" scroll={true} className="w-full h-[293px]">
                    <div className="relative w-full h-[293px] border-2 border-[#EBD29F] overflow-hidden cursor-pointer">
                        <Image
                            src={image || "/images/"}
                            alt={title || " "}
                            layout="fill"
                            objectFit="cover"
                            lang="pl"
                            loading="lazy"
                            quality={100}
                            className="hover:scale-110 duration-500 ease-in-out"
                        />
                    </div>
                </Link>
                <div className="flex flex-col gap-1 justify-start items-start w-full px-5 pt-4 pb-5">
                    <Link href={`https://beluxeproperties.com${slug || ""}`} className="text-[16px] font-bold leading-[24px] tracking-0 text-center text-white uppercase w-full font-['Comfortaa'] min-h-[54px] cursor-pointer">
                        {title?.slice(0, 56) || ""} {title?.length > 56 ? "..." : ""}
                    </Link>
                    <h5 className="text-[18px] font-bold leading-[24px] tracking-0 text-center text-[#EBD29F] uppercase w-full font-['Didot']">
                        € {formatPrice(price) || ""} 
                    </h5>
                    <h5 className="text-[14px] font-light leading-[24px] tracking-[0.25rem] text-center text-white uppercase w-full font-['Comfortaa']">
                        {ean || ""}
                    </h5>
                    <div className="flex flex-row gap-3 justify-around items-center w-full border-t-[#EBD29F] border-t-[0.5px] border-b-[#EBD29F] border-b-[0.5px] py-[10px]">
                        {bathrooms ? <h6 className="text-[14px] font-['Comfortaa'] text-white w-fit">Baths: {bathrooms || ""}</h6> : null}
                        {bedrooms ? <h6 className="text-[14px] font-['Comfortaa'] text-white w-fit">Bedrooms: {bedrooms || ""}</h6> : null}
                        {plot ? <h6 className="text-[14px] font-['Comfortaa'] text-white w-fit">Plot: {plot || ""}</h6> : null}
                        {built ? <h6 className="text-[14px] font-['Comfortaa'] text-white w-fit">Built: {built || ""}</h6> : null}
                    </div>
                    <Link href={`https://beluxeproperties.com${slug || ""}`} className="flex flex-row gap-2 justify-center items-center w-full pt-1">
                        <span className="text-[14px] text-[#EBD29F] font-medium leading-[22px] tracking-0 w-fit font-['Comfortaa']">see more</span>
                        <Image
                            src="/images/beluxe/arrow-right.svg"
                            alt="Arrow right icons"
                            layout="intrinsic"
                            width={13}
                            height={10}
                            loading="eager"
                            quality={100}
                        />
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default PropertyItem